export default __webpack_public_path__ + "static/o3_satellite_rotation_cropped-18b2ff327596e20b65efc8d96a573537.jpg";